import styled from 'styled-components';

const Container = styled.span`
  display: flex;
  align-items: center;

  svg {
    margin-left: ${({ theme }) => theme.spacing.S4};
    min-width: 20px;
  }
`;

const Title = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { Container, Title };
